import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/settings/order-customizations/')({});
